import {
  getPatientAssociatedFiles,
  getReferralAssociatedFiles,
  getScreeningAssociatedFiles,
} from "@/utils/fileUtil";
import type { PatientFile } from "@/features/patient/types/PatientFile";
import { sharedRequests } from "@/api/(requests)/shared";
import { sharedRequestsTyped } from "@/api/(requests)/sharedTyped";

import type { FileListData, FileListEntity, FileListParams, FileListType } from "../types";

// Only place that still branches on `type` — isolates the differing fetch signatures
// (urlParams vs searchParams) and response shapes (typed vs untyped) from the component.
export async function fetchEntityAndFiles(
  type: FileListType,
  params: FileListParams,
): Promise<FileListData> {
  if (type === "patient") {
    const patientId = params.patientId as string;
    const [response, files] = await Promise.all([
      sharedRequestsTyped.fetch_patient_details({ urlParams: { patientId } }),
      getPatientAssociatedFiles(patientId) as Promise<PatientFile[]>,
    ]);

    return { entity: response.user, files, id: patientId };
  }

  if (type === "referral") {
    const referralCode = params.referralCode as string;
    const [entity, files] = await Promise.all([
      sharedRequests.fetch_referral({
        context: undefined,
        searchParams: { referralCode },
      }) as Promise<FileListEntity>,
      getReferralAssociatedFiles(referralCode) as Promise<PatientFile[]>,
    ]);

    return { entity, files, id: referralCode };
  }

  const screeningId = params.screeningId as string;
  const [entity, files] = await Promise.all([
    sharedRequests.fetch_a5_screening_details({
      context: undefined,
      headers: undefined,
      searchParams: { screening_id: screeningId },
    }) as Promise<FileListEntity>,
    getScreeningAssociatedFiles(screeningId) as Promise<PatientFile[]>,
  ]);

  return { entity, files, id: screeningId };
}
